module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /produit/nodejs/bin/node-v14.19.0-linux-x64/lib/~/axios/index.js
// module id = 234
// module chunks = 0